'use client';

import { type StaticImport } from 'next/dist/shared/lib/get-img-props';

import { type ImageWithFallbackProps, ImageWithFallback } from '@shared/ui-components';

import DefaultFallbackImage from './fallback-image.svg';
import { DEFAULT_IMAGE_QUALITY, imageLoader } from './image-loader';

type ImageWrapperProps = Omit<ImageWithFallbackProps, 'fallbackSrc'> & {
  fallbackSrc?: string | StaticImport;
  hasDefaultFallback?: boolean;
};

export const ImageWrapper = ({
  fallbackSrc,
  hasDefaultFallback,
  quality,
  ...rest
}: ImageWrapperProps) => {
  return (
    <ImageWithFallback
      {...rest}
      fallbackSrc={fallbackSrc ? fallbackSrc : hasDefaultFallback ? DefaultFallbackImage : ''}
      loader={imageLoader}
      quality={quality ?? DEFAULT_IMAGE_QUALITY}
    />
  );
};
